export enum InvoiceStatusesEnum {
    'WAITING' = 'waiting',
    'IN_PROGRESS' = 'in_progress',
    'COMPLETED' = 'completed',
    'CANCELED' = 'canceled',
}
